/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeviceCoveragePassiveSpeakerUpdateFragment = { features: { coveragePosition: { xPosition: number | null, yPosition: number | null } | null } | { height: { height: number } | null } | { listenerHeight: { height: number } | null } | { rotation: { xAxis: number, yAxis: number, zAxis: number } | null } | {} };

export type PassiveSpeakerSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type PassiveSpeakerSubscriptionOpResult = { nodeChanges: DeviceCoveragePassiveSpeakerFragment | DeviceCoveragePassiveSpeakerUpdateFragment | {} };

export type DeviceCoveragePassiveSpeakerFragment = { id: string, isPassiveSpeakerNode: 'PassiveSpeaker', description: { constraints: { listenerHeight: { height: { range: { min: number, max: number, step: number } } } | null } }, features: { coveragePosition: { xPosition: number | null, yPosition: number | null } | null, height: { height: number } | null, rotation: { xAxis: number, yAxis: number, zAxis: number } | null, listenerHeight: { height: number } | null } };

export type DeviceCoveragePassiveSpeakerQueryVariables = Types.Exact<{
  nodeId: Types.Scalars['ID']['input'];
}>;


export type DeviceCoveragePassiveSpeakerQueryOpResult = { node: DeviceCoveragePassiveSpeakerFragment | {} };

export const DeviceCoveragePassiveSpeakerUpdateFragment = gql`
    fragment DeviceCoveragePassiveSpeakerUpdateFragment on PassiveSpeakerChange {
  features {
    ... on PassiveSpeakerCoveragePositionChange {
      coveragePosition {
        xPosition
        yPosition
      }
    }
    ... on PassiveSpeakerRotationChange {
      rotation {
        xAxis
        yAxis
        zAxis
      }
    }
    ... on PassiveSpeakerHeightChange {
      height {
        height
      }
    }
    ... on PassiveSpeakerListenerHeightChange {
      listenerHeight {
        height
      }
    }
  }
}
    `;
export const DeviceCoveragePassiveSpeakerFragment = gql`
    fragment DeviceCoveragePassiveSpeakerFragment on PassiveSpeaker {
  id
  isPassiveSpeakerNode: __typename
  description {
    constraints {
      listenerHeight {
        height {
          range {
            min
            max
            step
          }
        }
      }
    }
  }
  features {
    coveragePosition {
      xPosition
      yPosition
    }
    height {
      height
    }
    rotation {
      xAxis
      yAxis
      zAxis
    }
    listenerHeight {
      height
    }
  }
}
    `;
export const PassiveSpeakerSubscriptionDocument = gql`
    subscription PassiveSpeakerSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...DeviceCoveragePassiveSpeakerUpdateFragment
    ...DeviceCoveragePassiveSpeakerFragment
  }
}
    ${DeviceCoveragePassiveSpeakerUpdateFragment}
${DeviceCoveragePassiveSpeakerFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PassiveSpeakerSubscriptionGQL extends Apollo.Subscription<PassiveSpeakerSubscriptionOpResult, PassiveSpeakerSubscriptionVariables> {
    override document = PassiveSpeakerSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeviceCoveragePassiveSpeakerQueryDocument = gql`
    query DeviceCoveragePassiveSpeakerQuery($nodeId: ID!) {
  node(id: $nodeId) {
    ...DeviceCoveragePassiveSpeakerFragment
  }
}
    ${DeviceCoveragePassiveSpeakerFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeviceCoveragePassiveSpeakerQueryGQL extends Apollo.Query<DeviceCoveragePassiveSpeakerQueryOpResult, DeviceCoveragePassiveSpeakerQueryVariables> {
    override document = DeviceCoveragePassiveSpeakerQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }